export const USER_ID = "user_id";
export const ALTERNATE_LOGIN_ID = "loginId";
export const FIRST_NAME = "firstName";
export const LAST_NAME = "lastName";
export const MOBILE_NO = "phoneNumber";
export const LANDLINE_NO = "landlineNumber";
export const EMAIL_ID_1 = "email";
export const EMAIL_ID_2 = "email2";
export const ADDRESS = "address";
export const ADDRESS_1 = "addressLine1";
export const ADDRESS_2 = "addressLine2";
export const ZIPCODE = "zipCode";
export const STATE = "state";
export const CITY = "city";
export const PO_BOX = "pobox";
export const OCCUPANCY_TYPE = "occupancyType";
export const START_DATE = "startDate";
export const END_DATE = "endDate";
export const IS_BOM_USER = "isBomUser";
export const BOM_START_DATE = "bomStartDate";
export const BOM_END_DATE = "bomEndDate";
export const BOM_POSITION = "bomPositionId";
export const USERNAME = "userName";

export const occupancyTypes = [
  { label: "Owner", value: "owner" },
  // { label: "Tenant", value: "tenant" },
];
